import { render, staticRenderFns } from "./SpareFoot.vue?vue&type=template&id=c76cc9e0&scoped=true&"
import script from "./SpareFoot.vue?vue&type=script&lang=js&"
export * from "./SpareFoot.vue?vue&type=script&lang=js&"
import style0 from "./SpareFoot.vue?vue&type=style&index=0&id=c76cc9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76cc9e0",
  null
  
)

export default component.exports